/** Public logged-out entry, selected through tenant content presentation. */
import { AuthGateway } from "@/components/auth/AuthGateway";
import { MurtadaAcademyLanding } from "@/components/public/MurtadaAcademyLanding";
import { useTenantPresentation } from "@/hooks/use-tenant-presentation";
import { authFrontDoorForHostname } from "@/lib/supabase/auth-front-door";

export function LandingPage() {
  const { name: brandName, logoUrl, parentOrg, content } = useTenantPresentation();
  const authTransition = authFrontDoorForHostname()?.transition ?? "legacy";

  if (content.kind === "academy") {
    return (
      <MurtadaAcademyLanding
        brandName={brandName}
        logoUrl={logoUrl}
        parentOrg={parentOrg}
        content={content}
      />
    );
  }

  return (
    <AuthGateway
      authTransition={authTransition}
      brandName={brandName}
      content={content.authGateway}
      logoUrl={logoUrl}
    />
  );
}
